import type {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';
import {useHasModulePermission} from 'src/shared/auth/useHasModulePermission';

export interface PermissionGuardProps {
  module?: ModuleEnum;
  operation?: PermissionOperationEnum;
  operationName?: string;
  showDeniedMessage?: boolean;
  allowGlobalAdminBypass?: boolean;
  children?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  showDeniedMessage = false,
  module,
  operation,
  operationName,
  allowGlobalAdminBypass,
  children,
}) => {
  const {isSuperAdmin} = useAppSelector(state => state.session);
  const {hasPermission} = useHasModulePermission({
    module: module,
    operation: operation,
    operationName: operationName,
  });

  const bypassed = allowGlobalAdminBypass && isSuperAdmin;

  if (module && operation && hasPermission) {
    return <>{children}</>;
  } else if (!module || !operation || bypassed) {
    return <>{children}</>;
  }

  return (
    <>
      {showDeniedMessage === true &&
        'You do not have permission to access this feature.'}
    </>
  );
};
